import { useCallback, useMemo } from "react";
import { Text, Stack, Icon } from "@fluentui/react";
import { useTheme } from "cayo.ui";
import { IActionButton } from "@cayo/shared/api/types/schema";
import useService from "@cayo/shared/services/hooks/useService";
import { getTaskCardStyles } from "./TaskCard.styles";

export type TaskCardProps = IActionButton & { description?: string };

export const TaskCard = (props: TaskCardProps) => {
  const { text, icon, description, action, actionParameters } = props;
  const actionBuilder = useService("actionBuilder");
  const { officeTheme: theme } = useTheme();
  const styles = useMemo(() => getTaskCardStyles(theme), [theme]);

  const handleClick = useCallback(() => {
    actionBuilder.buildAction(action!, { actionParameters });
  }, [action, actionParameters, actionBuilder]);

  return (
    <div className={styles.card} role="button" tabIndex={0} onClick={handleClick}>
      <Stack verticalAlign="center" horizontalAlign="center">
        <div className={styles.iconContainer}>
          <Icon iconName={icon?.iconName} className={styles.title} />
        </div>
        <Text variant="large" className={styles.title}>
          {text}
        </Text>
        <Text variant="small">{description}</Text>
      </Stack>
    </div>
  );
};
